<ng-container *ngIf="items$ | async as items">
  <div class="search-empty-wrapper">
    <div class="container">
      <label>{{ title$ | async }}</label>
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" *ngIf="items.length > 0" [config]="slickConfig">
        <div ngxSlickItem *ngFor="let item of items; let i = index" class="slide">
          <div class="item" *ngIf="item | async as data">
            <a
              tabindex="0"
              [routerLink]="{ cxRoute: 'product', params: data } | cxUrl"
              (click)="gtmProductClick(data, i + 1)"
            >
              <div class="prod-image">
                <div>
                  <cx-media
                    [container]="getImageRendition(data?.images?.PRIMARY)"
                    format="product"
                    [class.is-missing-fish]="businessType === 'fish'"
                  ></cx-media>
                </div>
              </div>
              <div class="prod-body">
                <div class="prod-code">{{ data.code }}</div>
                <div class="prod-name">{{ data.name }}</div>
                <div class="prod-price">
                  <ng-container>
                    <ng-template [ngIf]="!showSrp">
                      <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
                      <span class="p-price">
                        <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(data.code); else dealerPriceReady">
                          <div class="spinner-shimano" *ngIf="this.hasDealerPrice">
                            <div></div>
                          </div>
                          <div class="no-dealer-price no-dealer-price-alt" *ngIf="!this.hasDealerPrice"></div>
                        </div>
                        <ng-template #dealerPriceReady>
                          {{ dealerPrice(data.code) }}
                        </ng-template>
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="showSrp">
                      <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
                      <span class="p-price">
                        {{ data.srpPrice?.formattedValue }}
                      </span>
                    </ng-template>
                  </ng-container>
                </div>
              </div>
            </a>
            <div class="prod-bottom container">
              <div class="row">
                <div class="col-sm-6">
                  <a tabindex="0" class="pdp-link" [routerLink]="{ cxRoute: 'product', params: data } | cxUrl">
                    <mat-icon class="material-icons-sharp light">assignment</mat-icon>
                  </a>
                </div>
                <div class="col-sm-6">
                  <a tabindex="0" class="order-form" href="#">
                    <mat-icon class="material-icons-sharp light">note_add</mat-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
</ng-container>
